import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GenerateCvService } from 'src/app/services/generate-cv/generate-cv.service';

@Component({
  selector: 'app-select-resume',

  templateUrl: './select-resume.component.html',
  styleUrls: ['./select-resume.component.css'],
})
export class SelectResumeComponent {
  @Input() formGroup!: FormGroup;
  
  selectedResumeType: string = 'scratch';
  @Output() next = new EventEmitter<any>();
  @Output() previous = new EventEmitter<void>();
  IsUploadCv = false;
  loading = false;
  cv: any = null;

  constructor(private generateCvService: GenerateCvService, private fb: FormBuilder) {}

  onCVDrop(event: any) {
    event.preventDefault();

    this.cv = event.dataTransfer.files[0];
    this.next.emit();
  }

  onCVSelected(event: any) {
    this.cv = event.target.files[0];
  console.log('Selected file:', this.cv);
    const formData = new FormData();
    formData.append('cv', this.cv);
    this.loading = true;
    this.generateCvService.uploadExistingCv(formData).subscribe((cvJson: any) => {
      this.patchFormValues(cvJson);
      this.loading = false;
      this.next.emit();
    });
  }

  patchFormValues(cvJson: any) {
    this.formGroup.patchValue({
      name: cvJson.name,
      title: cvJson.title,
      city: cvJson.city,
      phone: cvJson.phone,
      linkedIn: cvJson.linkedIn,
      country: cvJson.country ?? "",
      email: cvJson.email,
      summary: cvJson.summary,
      target: this.formGroup.value.target ?? [],
      cvTempletePath: this.formGroup.value.cvTempletePath ?? '',
      cvTempleteFile: this.formGroup.value.cvTempleteFile ?? '',
      coverLetterPath: this.formGroup.value.coverLetterPath ?? '',
    });
  
    this.updateFormArray('skill', cvJson.skill);
    this.updateLanguages(cvJson.languages);
    this.updateFormArray('course', cvJson.course);
    this.updateFormArray('certification', cvJson.certification);
    this.updateFormArray('project', cvJson.project);
    this.updateExperiences(cvJson.experiences);
    this.updateEducation(cvJson.education);
  }  

  updateFormArray(field: string, values: any[]) {
    const control = this.formGroup.get(field) as FormArray;
    control.clear();
    values.forEach(value => control.push(new FormControl(value)));
  }
  
  updateLanguages(languages: any[]) {
    const control = this.formGroup.get('languages') as FormArray;
    control.clear();
    languages.forEach(lang => {
      control.push(
        this.fb.group({
          name: [lang.name, Validators.required],
          level: [lang.level],
        })
      );
    });
  }
  
  updateExperiences(experiences: any[]) {
    const control = this.formGroup.get('experiences') as FormArray;
    control.clear();
    experiences.forEach(exp => {
      control.push(
        this.fb.group({
          title: [exp.title, Validators.required],
          startDate: [this.formatDate(exp.startDate), Validators.required],
          endDate: [this.formatDate(exp.endDate)],
          company: [exp.company, Validators.required],
          isCurrent: [exp.isCurrent],
          objective: [exp.objective],
        })
      );
    });
  }
  
  updateEducation(education: any[]) {
    const control = this.formGroup.get('education') as FormArray;
    control.clear();
    education.forEach(edu => {
      control.push(
        this.fb.group({
          major: [edu.major, Validators.required],
          university: [edu.university, Validators.required],
          degree: [edu.degree, Validators.required],
          startDate: [this.formatDate(edu.startDate), Validators.required],
          grade: [edu.grade],
        })
      );
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    return date.toISOString().split('T')[0];
  }
  
  
  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onNext() {
    if (this.selectedResumeType === 'upload') {
      this.IsUploadCv = true;
    } else {
      this.next.emit();
    }
  }

  onPrevious() {
    if (this.IsUploadCv === true) {
      this.IsUploadCv = false;
    } else {
      this.previous.emit();
    }
  }
}
